import { createContext, useContext, useEffect, useMemo, useState } from 'react';

const PrefsContext = createContext(null);

export function PrefsProvider({ children }) {
  const [theme, setTheme] = useState(() => localStorage.getItem('prefs.theme') || 'light');
  const [fontSize, setFontSize] = useState(() => localStorage.getItem('prefs.fontSize') || 'md');

  useEffect(() => {
    localStorage.setItem('prefs.theme', theme);
    const html = document.documentElement;
    if (theme === 'dark') html.classList.add('theme-dark');
    else html.classList.remove('theme-dark');
  }, [theme]);

  useEffect(() => {
    localStorage.setItem('prefs.fontSize', fontSize);
    const html = document.documentElement;
    html.classList.remove('fs-sm', 'fs-md', 'fs-lg');
    html.classList.add(`fs-${fontSize}`);
  }, [fontSize]);

  const value = useMemo(() => ({ theme, setTheme, fontSize, setFontSize }), [theme, fontSize]);
  return <PrefsContext.Provider value={value}>{children}</PrefsContext.Provider>;
}

export function usePrefs() {
  const ctx = useContext(PrefsContext);
  if (!ctx) throw new Error('usePrefs must be used within PrefsProvider');
  return ctx;
}
